// import Cookies from 'js-cookie';
import { Navigate, Outlet } from 'react-router-dom';
import { RoutePaths } from './RoutePaths';
import { isLoggedIn } from '../base';

const NonAuthLayout = () => {
    const isAuthenticated = isLoggedIn();

    return !isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to={RoutePaths.dashboard} replace />
    );
};

export default NonAuthLayout;
